/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_FeaturedInputs */

const en_blog_featured = /** @type {(inputs: Blog_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const pl_blog_featured = /** @type {(inputs: Blog_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polecane`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Blog_FeaturedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const blog_featured = /** @type {((inputs?: Blog_FeaturedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_FeaturedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_blog_featured(inputs)
	return en_blog_featured(inputs)
});